import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import WorkshopB2BDataService from "../../services/WorkshopB2B";
import { Loader } from "../../components/Loader/Loader";


export const WorkshopB2BView = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [row, setRow] = useState<any>();
  const { id } = useParams();
  // console.log(id);

  const fetchData = () => {
    setIsLoading(true);
    WorkshopB2BDataService.getB2BWorkshop(String(id))
      .then((res) => {
        const data = res.data;
        setRow(data.data);
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
        console.log(e);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="main-wrapper">
      <div className="page_title py-2">B2B Workshop - View</div>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="p-5">
          {row ? (
            <div className="main-section">
              <div className="row justify-content-center client-detail-sec ">
                <div className="col-sm-12 card p-3">
                  <div className="row justify-content-center">
                    <div className="col-sm-6 px-4">
                      <table className="table table-striped border-0 mt-4">
                        <tbody>
                          <tr>
                            <th>Workshop id:</th>
                            <td>{row._id}</td>
                          </tr>
                          <tr>
                            <th>Workshop Title:</th>
                            <td>{row.title}</td>
                          </tr>
                          <tr>
                            <th>Workshop Date:</th>
                            <td>{row.date}</td>
                          </tr>
                          <tr>
                            <th>Workshop Start Time:</th>
                            <td>{row.start_time}</td>
                          </tr>
                          <tr>
                            <th>Workshop End Time:</th>
                            <td>{row.end_time}</td>
                          </tr>
                          <tr>
                            <th>Status:</th>
                            <td>{row.status}</td>
                          </tr>
                          <tr>
                            <th>Location:</th>
                            <td>{row.location}</td>
                          </tr>
                          <tr>
                            <th>State:</th>
                            <td>{row.state}</td>
                          </tr>
                          <tr>
                            <th>Client:</th>
                            <td>{row.corporate}</td>
                          </tr>
                          <tr>
                            <th>Expert Name:</th>
                            <td>{row.expert_name}</td>
                          </tr>
                          <tr>
                            <th>Expert Price:</th>
                            <td>{row.expert_price}</td>
                          </tr>
                          <tr>
                            <th>TDS:</th>
                            <td>{row.tds}</td>
                          </tr>
                          <tr>
                            <th>Payment After TDS:</th>
                            <td>{row.payment_after_tds}</td>
                          </tr>
                          <tr>
                            <th>Payment Status:</th>
                            <td>{row.payment_status}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Loader />
          )}
        </div>
      )}
    </div>
  );
};
